import React from 'react';
import PostLoginRedirect from './PostLoginRedirect';
const Dashboard = () => <PostLoginRedirect />;
export default Dashboard;
